<!-- <ng-template #chatbox> -->
<!-- <h1>Working</h1> -->
<div class="page_wrapper">
  <!--<div class="row">-->
  <!--<div class="mx-auto">-->
  <div class="chatLogo">
    <a href="{{ homePageUrl }}" class="link-hover">
      <img src="/assets/images/logo1.svg" class="ml-4 mb-2 mt-2" />
    </a>
  </div>
  <div class="testclass" (click)="focus = true" [ngClass]="{ focusClass: focus === true }">
    <label *ngIf="isEditable" class="chat-btn" for="check" (click)="isChatOpen = isChatOpen ? false : true">
      <i class="fa fa-commenting-o comment"></i>
    </label>
    <div *ngIf="isChatOpen">
      <form [formGroup]="chatForm" #chatMsgForm>
        <div class="card border-primary border-2 chatBoxHeight">
          <!-- flex -->
          <div
            class="card-header d-flex justify-content-between card-header-color text-white font-size-15 font-weight-600">
            <div>CHAT BOX</div>
            <div *ngIf="room_id">Room Id: {{ room_id }}</div>
            <div>
              <a *ngIf="enableCallButton" style="left: 20px; font-size: 25px; color: cyan" class="fa mr-2 cursor"
                [ngClass]="{
                  'fa-phone': audioCall,
                  'fa-video-camera': videoCall
                }" aria-hidden="true" (click)="joinCallRoom()"></a>
              <!-- <span class="closeModal" (click)="closeModal()">&times;</span> -->
              <button *ngIf="!isMinimize" type="button" class="close mr-2" (click)="isChatOpen = false">
                &times;
              </button>
            </div>
            <!-- close button -->
          </div>
          <div class="card-body chat-care" #chatScroll [scrollTop]="chatScroll.scrollHeight">
            <div *ngIf="!chatStarted; else elseSession" class="text-center">
              <label>------ No Messages ------</label>
            </div>
            <ng-template #elseSession>
              <div class="text-center">
                <label>------ Session started ------</label>
              </div>
            </ng-template>
            <ul class="chat" *ngFor="let msg of messages; let i = index">
              <li *ngIf="msg.id == appointment?.pid" class="patientChat clearfix">
                <span class="chat-img float-right mx-1">
                  <i class="fa fa-user" style="font-size: 23px; color: orange" alt="Patient"></i>
                </span>
                <div class="chat-body-patient">
                  <div class="header clearfix">
                    <small class="left text-muted">
                      <span class="glyphicon glyphicon-time"></span>
                      {{ msg.date | date: "dd-MMM-yyyy (HH:mm)" }}</small>&nbsp;&nbsp;
                    <strong class="right primary-font mr-2" style="color: orange">{{ patient?.first_name }}</strong>
                  </div>

                  <p *ngIf="checkMsgType(msg.body) === 'string'">
                    {{ msg.body }}
                  </p>

                  <video *ngIf="checkMsgType(msg.body) === 'video'" src="{{ msg.body?.previewUrl }}" id="chatVideo"
                    style="width: 250px" alt="video" type="video/mp4" controls></video>

                  <img *ngIf="checkMsgType(msg.body) === 'image'" style="width: 100%" src="{{ msg.body?.previewUrl }}"
                    id="chatImage" (click)="previewImg(i)" alt="image" />

                  <a *ngIf="checkMsgType(msg?.body) === 'application'" class="fa fa-file-pdf-o ml-2">
                    <br />
                    <a href="javascript:void(0);" aria-hidden="true" (click)="previewImg(i)"
                      style="color: blue; font-weight: normal">&nbsp;{{ msg.body?.name }}</a>
                  </a>
                </div>
                <i *ngIf="
                    checkMsgType(msg.body) === 'video' ||
                    checkMsgType(msg.body) === 'image' ||
                    checkMsgType(msg.body) === 'application'
                  " class="fa fa-download ml-2" aria-hidden="true" style="font-size: 15px; cursor: pointer"
                  (click)="downloadDocument(msg.body)"></i>
              </li>
              <li *ngIf="msg.id == appointment?.drid" class="physicianChat clearfix">
                <span class="chat-img float-left clearfix mx-1">
                  <i class="fa fa-user-md" style="font-size: 23px; color: blue" alt="Physician"></i>
                </span>
                <div class="chat-body-physician clearfix">
                  <div class="header clearfix float-left">
                    <small class="left text-muted">
                      <span class="glyphicon glyphicon-time"></span>
                      {{ msg.date | date: "dd-MMM-yyyy (HH:mm)" }}</small>&nbsp;&nbsp;
                    <strong class="right primary-font mr-2" style="color: blue">{{ physicianDetail?.first_name
                      }}</strong>
                  </div>

                  <img *ngIf="checkMsgType(msg?.body) === 'image'" style="width: 100%" src="{{ msg.body?.previewUrl }}"
                    id="chatImage" alt="image" />

                  <p *ngIf="checkMsgType(msg.body) === 'string'">
                    {{ msg.body }}
                  </p>

                  <video *ngIf="checkMsgType(msg.body) === 'video'" src="{{ msg.body?.previewUrl }}" id="chatVideo"
                    style="width: 250px" alt="video" type="video/mp4" controls></video>

                  <a *ngIf="checkMsgType(msg?.body) === 'application'" class="fa fa-file-pdf-o ml-2">
                    <br />
                    <a href="javascript:void(0);" aria-hidden="true" (click)="previewImg(i)"
                      style="color: blue; font-weight: normal">&nbsp;{{ msg.body?.name }}</a>
                  </a>
                </div>
                <i *ngIf="
                    checkMsgType(msg.body) === 'video' ||
                    checkMsgType(msg.body) === 'image' ||
                    checkMsgType(msg.body) === 'application'
                  " class="fa fa-download ml-2" aria-hidden="true" style="font-size: 15px; cursor: pointer"
                  (click)="downloadDocument(msg.body)"></i>
              </li>
            </ul>
            <ul *ngIf="typingStatus?.status" class="typing-status">
              {{
              typingStatus?.status
              }}...
            </ul>
          </div>
          <div class="card-footer card-footer-color">
            <div *ngIf="!chatStarted && room_id" class="text-center">
              <button class="btn btn-primary" (click)="startChat()">
                START CHAT
              </button>
            </div>

            <div *ngIf="chatStarted" class="input-group">
              <textarea id="btn-input" type="text" formControlName="chat_msg" class="form-control input-sm"
                placeholder="Type your message here..." rows="2" cols="3" style="line-height: 2; overflow: hidden"
                (keydown)="sendStatusTyping($event)" (keydown.enter)="sendMessage()"></textarea>
              <div class="image-upload">
                <label class="btn btn-outline-secondary calendar rounded-0" for="file-input"
                  style="line-height: 2.5; background: white" id="attachFile">
                  <span class="fa fa-paperclip fa-rotate-90" style="font-size: 32px; color: black"></span>
                </label>
                <input id="file-input" type="file" accept="application/pdf, image/*, docx/*"
                  (change)="selectFile($event)" />
              </div>
              <span class="input-group-btn">
                <button class="btn btn-primary mt-2 ml-2" id="btn-chat" (click)="sendMessage()">
                  <i class="fa fa-paper-plane"></i>
                </button>
              </span>
            </div>
          </div>
        </div>
      </form>
      <!--</div>-->
      <!--</div>-->
    </div>
  </div>
</div>

<!-- notification -->
<ng-template #callNotification let-c="close" let-d="dismiss">
  <div class="modal-header">
    <h2 class="modal-title">Physician Requesting a video call </h2>
  </div>

  <!-- modal header -->

  <div class="modal-body">
    Accept Incoming call
    <!-- modal content -->
  </div>

  <div class="modal-footer d-flex justify-content-center">
    <button type="button" class="btn btn-primary" (click)="joinCallRoom()">
      Accept
    </button>

    <button type="button" class="btn btn-outline-primary" (click)="closePopUp()">
      Decline
    </button>
  </div>
</ng-template>

<div *ngIf="showOnlineJoinCall" (click)="focus = false">
  <div id="cdk" [ngClass]="{
      'video-screen': isMinimize === false,
      minWindow: isMinimize === true
    }" style="transform: translate3d(0px, 111px, 0px)" cdkDrag>
    <div>
      <div>
        <div class="float-right">
          <span *ngIf="!isMinimize" class="mr-2 mt-2 cursor" (click)="markMinimize()">
            <b>_</b>
          </span>
          <img style="padding-top: 17px" *ngIf="isMinimize" width="10px" class="mr-2 cursor"
            src="../../../assets/images/maximize.svg" (click)="isMinimize = false" />
          <button type="button" class="close mt-2 mr-2" (click)="closeVideoScreen()">
            &times;
          </button>
        </div>
        <div *ngIf="!isMinimize">
          <h3>Call</h3>
        </div>
        <!-- <i class="fa fa-close font-size-14"> Press Escape key to clsoe the preview</i> -->
      </div>
      <app-home [isMinimize]="isMinimize" [aptid]="aptid" [role]="role"></app-home>
    </div>
  </div>
</div>
<!-- Join ChatRoom Notification -->
<ng-template #joinChatNotification let-c="close" let-d="dismiss">
  <div class="modal-header">
    <h2 class="modal-title">Join Chat Notification</h2>
  </div>

  <!-- modal header -->

  <div class="modal-body">
    {{ notificationMessage }}
    <!-- modal content -->
  </div>

  <div class="modal-footer d-flex justify-content-center">
    <button type="button" class="btn btn-primary" (click)="closeJoinChatModal()">
      ok
    </button>
  </div>
</ng-template>

<!-- end -->
<ng-template #PDFModal>
  <div>
    <div class="modal-header">
      <!-- <i class="fa fa-close font-size-14"> Press Escape key to clsoe the preview</i> -->
      <button type="button" class="close" (click)="closeModal()">
        &times;
      </button>
    </div>
    <div>
      <pdf-viewer [src]="pdfSrc" [render-text]="true" style="display: block"></pdf-viewer>
    </div>
  </div>
</ng-template>